import { useEffect } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { reportQuery, useReport, useReportActions } from "@/api/reports";
import { Page, PageHeader } from "@/components/shell/PageHeader";
import { Markdown } from "@/components/common/Markdown";
import { Button } from "@/components/ui/button";
import { humanDate } from "@/lib/labels";

export const Route = createFileRoute("/_app/reports/$reportId")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(reportQuery(params.reportId)),
  component: ReportPage,
});

function ReportPage() {
  const { reportId } = Route.useParams();
  const report = useReport(reportId);
  const { markRead } = useReportActions();
  const r = report.data;
  useEffect(() => {
    if (r && !r.read && r.status === "ready") markRead.mutate(r.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [r?.id, r?.read]);
  if (!r) return null;
  return (
    <>
      <PageHeader
        title={r.headline ?? "Report"}
        subtitle={`${r.kind} · ${humanDate(r.period_start)} to ${humanDate(r.period_end)}`}
        actions={
          <Button asChild variant="ghost" size="sm">
            <Link to="/reports">
              <ArrowLeft className="size-4" /> All reports
            </Link>
          </Button>
        }
      />
      <Page>
        {r.status === "failed" ? (
          <p className="text-sm text-danger">Generation failed: {r.error}</p>
        ) : (
          <article className="rounded-lg border bg-card px-6 py-5">
            <Markdown>{r.markdown ?? ""}</Markdown>
          </article>
        )}
      </Page>
    </>
  );
}
